import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../../App";
import Finish from "../../../../../assets/images/finish.png";
import Flag from "../../../../../assets/images/flag.png";
import Cup from "../../../../../assets/images/liveAudition.png";
import Panding from "../../../../../assets/images/Pandding.png";
import PriceTag from "../../../../../assets/images/tagPrice.PNG";
import Video from "../../../../../assets/images/Videox.png";
import LearningLiveSession from "./LearningLiveSession";
import "./SuperStarContent.css";

const LearningSessionEvaluationDetails = (props) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const [event, setEvent] = useState("");
  const [convertedContent, setConvertedContent] = useState("");

  const fetchData = (event_slug) => {
    axios
      .get(`/api/admin/learning_session/details/${event_slug}`)
      .then((res) => {
          if (res.data.status === 200) {
            setEvent(res.data.event);
          }
      });
  };

  useEffect(() => {
    const event_slug = props.match.params.slug;
    fetchData(event_slug);
  }, [props.match.params.slug, history]);

  const [eventData, setEventData] = useState({
    fee: "",
    start_date: "",
    end_date: "",
    slot_number: "",
    error_list: [],
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEventData((prev) => {
      return { ...prev, [name]: value };
    });
    e.persist();
    setEventData({ ...eventData, [e.target.name]: e.target.value });
  };

  const formSubmit = (e) => {
    e.preventDefault();

    const fData = new FormData();

    fData.append("id", event.id);
    fData.append("instruction", convertedContent);
    fData.append("fee", eventData.fee);
    fData.append("start_date", eventData.start_date);
    fData.append("end_date", eventData.end_date);
    fData.append("slot_number", eventData.slot_number);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/admin/learning_session/add_assignment_rules`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            fetchData(event.id);
            // history.push("/superstar-admin/live-chat/pending");
          } else {
            setEventData({
              ...eventData,
              error_list: res.data.errors,
            });
          }
        });
    });
  };

  return (
    <>
      <div className="card card-bg head-line  mb-3">
        <div className="text-light d-flex p-2">
          <div className="faTrophy">
            <i className="fas fa-trophy"></i>
          </div>
          <h4 className="mx-3 text-white p-2">{event?.title}</h4>
        </div>
      </div>

      {Number(event?.status) < 4 ? (
        <>
          <div className="d-flex card-bg p-2 rounded-3 justify-content-center">
            {event?.banner ? (
              <img
                src={imageCdnUrl + event?.banner}
                alt=""
                className="img-fluid card-img-details"
              />
            ) : (
              <>
                <ReactPlayer
                  url={videoCdnUrl + event?.video}
                  controls={true}
                  volume={1}
                  width="100%"
                  maxHeight="450px"
                  style={{ margin: "0 auto" }}
                />
              </>
            )}
          </div>
          <div className="FromDiv card-bg p-2 my-3 rounded-3">
            <h4 className="text-warning fw-bold p-3 ">
              Upload Video Instruction
            </h4>
            <form action="" className="row justify-content-center">
              <div className="col-md-12 mb-3">
                <CKEditor
                  data={convertedContent}
                  editor={ClassicEditor}
                  onChange={(event, editor) => {
                    setConvertedContent(editor.getData());
                  }}
                  className="w-100"
                />
                <small className="text-danger">
                  {eventData.error_list?.instruction}
                </small>
                {/* <input type="text" className="form-control w-100 mt-3" /> */}
              </div>

              <div className="col-md-6 col-lg-3 m-0 ">
                <div className="d-flex registration-btn p-2 align-items-center ">
                  <div className="">
                    <span className="text-light">
                      <img src={PriceTag} alt="" className=" px-3" />
                    </span>
                  </div>
                  <div className="px-2">
                    <span className="text-light smallTxtP">
                      Certificate Apply price
                    </span>
                    <br></br>
                    <input
                      className="form-control reply-control mt-1"
                      placeholder="Enter fee $"
                      onChange={handleInput}
                      name="fee"
                      value={eventData.fee}
                    />
                    <small className="text-danger">
                      {eventData.error_list?.fee}
                    </small>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-3 m-0 ">
                <div className="d-flex registration-btn p-2 align-items-center ">
                  <div className="">
                    <span className="text-light">
                      <img src={Flag} alt="" className=" px-3" />
                    </span>
                  </div>
                  <div className="">
                    <span className="text-light smallTxtP">Start:</span>
                    <br></br>
                    <input
                      className="form-control input-gray mt-1"
                      type="date"
                      onChange={handleInput}
                      name="start_date"
                      value={eventData.start_date}
                    />
                    <small className="text-danger">
                      {eventData.error_list?.start_date}
                    </small>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-3 m-0 ">
                <div className="d-flex registration-btn p-2 align-items-center ">
                  <div className="">
                    <span className="text-light">
                      <img src={Finish} alt="" className=" px-3" />
                    </span>
                  </div>
                  <div className="">
                    <span className="text-light smallTxtP">End</span>
                    <br></br>
                    <input
                      className="form-control input-gray mt-1"
                      type="date"
                      onChange={handleInput}
                      name="end_date"
                      value={eventData.end_date}
                    />
                    <small className="text-danger">
                      {eventData.error_list?.end_date}
                    </small>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-3 m-0 ">
                <div className="d-flex registration-btn p-2 align-items-center ">
                  <div className="">
                    <span className="text-light">
                      <img src={Video} alt="" className=" px-3" />
                    </span>
                  </div>
                  <div className="px-2">
                    <span className="text-light smallTxtP">
                      {" "}
                      User uploaded slot
                    </span>
                    <br></br>
                    <input
                      type="number"
                      className="form-control reply-control mt-1"
                      placeholder="3 video"
                      onChange={handleInput}
                      name="slot_number"
                      value={eventData.slot_number}
                    />

                    <small className="text-danger">
                      {eventData.error_list?.slot_number}
                    </small>
                  </div>
                </div>
              </div>

              <div className="col-md-12 my-3">
                <center>
                  <button
                    className="btn btnCreate fw-bold"
                    onClick={formSubmit}
                  >
                    Submit
                  </button>
                </center>
              </div>
            </form>
          </div>
        </>
      ) : Number(event?.status) === 4 ? (
        <>
          <div className="d-flex card-bg p-2 rounded-3 justify-content-center">
            {event?.banner ? (
              <img
                src={imageCdnUrl + event?.banner}
                alt=""
                className="img-fluid card-img-details"
              />
            ) : (
              <>
                <ReactPlayer
                  url={videoCdnUrl + event?.video}
                  controls={true}
                  volume={1}
                  width="100%"
                  maxHeight="450px"
                  style={{ margin: "0 auto" }}
                />
              </>
            )}
          </div>

          <div className="row my-4">
            <div className="col-md-12">
              <div className="card card-bg shadow border-warning">
                <div className="card-body">
                  <div className="d-flex  ">
                    <div className="faTrophy">
                      <img src={Cup} alt="" />
                    </div>

                    <h5 className="mx-3 text-white pt-3">
                      Waiting for the Manager Approval
                    </h5>
                  </div>

                  <center className="mt-3">
                    <img className="w-25" src={Panding} alt="" />
                    <h4 className="my-4 text-warning fs-4">
                      Pending For Manager Admin Approval
                    </h4>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : Number(event?.status) > 4 ? (
        <LearningLiveSession event={event}></LearningLiveSession>
      ) : (
        ""
      )}
    </>
  );
};

export default LearningSessionEvaluationDetails;
